module.exports = __webpack_public_path__ + "static/img/GoldenMiner-zh.8e7e71bd.png";